if (!customElements.get('tile-care-upsell')) {
  class TileCareUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tile-care-track]');
      this.previousButton = this.querySelector('[data-tile-care-previous]');
      this.nextButton = this.querySelector('[data-tile-care-next]');
      this.controls = this.querySelector('.TileCareUpsell__controls');

      if (!this.track || !this.previousButton || !this.nextButton || !this.controls) return;

      this._onPrevious = this._move.bind(this, -1);
      this._onNext = this._move.bind(this, 1);
      this._onScroll = this._requestUpdate.bind(this);
      this._onKeydown = this._handleKeydown.bind(this);
      this._onResize = this._updateControls.bind(this);

      this.previousButton.addEventListener('click', this._onPrevious);
      this.nextButton.addEventListener('click', this._onNext);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('keydown', this._onKeydown);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this._onResize);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this._onResize);
      }

      window.requestAnimationFrame(this._updateControls.bind(this));
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.previousButton.removeEventListener('click', this._onPrevious);
      this.nextButton.removeEventListener('click', this._onNext);
      this.track.removeEventListener('scroll', this._onScroll);
      this.track.removeEventListener('keydown', this._onKeydown);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', this._onResize);
      }

      if (this.updateFrame) window.cancelAnimationFrame(this.updateFrame);
    }

    _getStep() {
      var firstCard = this.track.querySelector('.TileCareUpsell__card');
      if (!firstCard) return this.track.clientWidth;

      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      var cardStep = firstCard.getBoundingClientRect().width + gap;

      return firstCard.getBoundingClientRect().width > this.track.clientWidth * 0.65
        ? cardStep
        : Math.max(cardStep, this.track.clientWidth - gap);
    }

    _move(direction) {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * this._getStep(),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    _handleKeydown(event) {
      if (event.target !== this.track) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this._move(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this._move(1);
      }
    }

    _requestUpdate() {
      if (this.updateFrame) return;

      this.updateFrame = window.requestAnimationFrame(function () {
        this.updateFrame = null;
        this._updateControls();
      }.bind(this));
    }

    _updateControls() {
      var maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var hasOverflow = maximumScroll > 2;

      this.controls.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || this.track.scrollLeft <= 2;
      this.nextButton.disabled = !hasOverflow || this.track.scrollLeft >= maximumScroll - 2;
    }
  }

  customElements.define('tile-care-upsell', TileCareUpsell);
}
